






























































































































import Vue from 'vue'
import { Location, OAuth2 } from '@/models'
import config from '@/config'
import FacebookBusinessModal from './FacebookBusinessModal.vue'
import FacebookIcon from '@/assets/pmd/img/launchpad/icon-facebook.svg'
import AlertTriangleIcon from '@/assets/pmd/img/launchpad/alert-triangle.svg'
import { trackGaEvent, trackPendoEvent } from '@/util/helper'
import { AppEngineService } from '../../../services'

declare var $: any
let openedWindow: Window | null

// Create IE + others compatible event handler
const eventMethod: string = window.addEventListener
  ? 'addEventListener'
  : 'attachEvent'
const win: any = window
const eventer = win[eventMethod]
const messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message'

// Listen to message from child window
eventer(
  messageEvent,
  function (e) {
    if (e.data && e.data.page === 'integrations_settings') {
      if (e.data.actionType === 'close' && openedWindow) {
        openedWindow.close()
      }
    }
  },
  false
)

export default Vue.extend({
  props: ['currentLocationId', 'userid', 'name'],
  components: {
    FacebookBusinessModal,
    FacebookIcon,
    AlertTriangleIcon,
  },
  data() {
    return {
      location: {} as Location,
      slideShow: false,
      fbAuth: false,
      showModal: false,
      facebookPages: [],
      selectedPage: undefined as { [key: string]: any } | undefined,
      processing: false,
      selectedId: '',
      connectLoader: false,
      disableHandler: {
        action: 'facebook',
        disable: false,
      },
      facebookConnection: undefined as OAuth2 | undefined,
    }
  },
  computed: {
    isUserSwitched() {
      return this.$store.getters['auth/isProxyUser'];
    },
    isFbConnected(): boolean | undefined {
      return this.location.facebookPageId ? true : false
    },
    adminOrOwnerOfFacebookIntegration() {
      if (this.isUserSwitched) { // Hide for switched users
        return false
      }
      // If the field doesn't exists any user should be able to edit the pages.
      if (!this.facebookConnection || !this.facebookConnection.ownerId)
        return true

      return this.facebookConnection.ownerId === this.userid || this.facebookConnection?.users[this.userid]
    },
    btnText(): string {
      let btnTxt = 'Connect'
      if (this.reconnect) {
        btnTxt = !this.adminOrOwnerOfFacebookIntegration ? 'Un Authorized' : 'Reconnect'
      }
      return this.connectLoader ? 'Connecting...' : btnTxt
    },
    reconnect(): boolean | undefined {
      return (
        (this.location.isFbDisconnected && !this.isFbConnected) ||
        (this.facebookConnection && this.location.fbTokenExpired)
      )
    },
    disableButton(): string {
      return this.slideShow ? 'pointer-events:none !important' : ''
    },
  },
  watch: {
    '$route.params.location_id': async function (id) {
      this.location = new Location(
        await this.$store.dispatch('locations/getCurrentLocation', id)
      )
      if (!this.isFbConnected) await this.fetchData()
      if (this.facebookPages.length > 0 && !this.location.facebookPageId) {
        this.fbAuth = true
      }
    },
  },
  async mounted() {
    this.location = new Location(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.currentLocationId
      )
    )
    this.$root.$on('fb-connect', () => {
      this.showModal = false
      this.connectFacebook()
    })
    this.$root.$on('close-modal', () => {
      this.showModal = false
    })
    const $selectpicker = $(this.$el).find('.selectpicker')
    if ($selectpicker) {
      $selectpicker.selectpicker('refresh')
    }
    if (!this.isFbConnected) await this.fetchData()
    if (this.facebookPages.length > 0 && !this.location.facebookPageId) {
      this.fbAuth = true
    }
  },
  updated() {
    const $selectpicker = $(this.$el).find('.selectpicker')
    if ($selectpicker) {
      $selectpicker.selectpicker('refresh')
      if (
        this.company &&
        this.company.country == 'US' &&
        this.$refs.stateSelect
      ) {
        $(this.$refs.stateSelect).selectpicker('val', this.company.state)
      }
    }
  },
  methods: {
    connectFacebook() {
      trackGaEvent(
        'Launchpad',
        'Initiate Facebook connect',
        `Init Facebook connect for location: ${this.currentLocationId}`
      )
      this.disableHandler.disable = true
      this.$root.$emit(
        'disable-launchpad-action',
        JSON.stringify(this.disableHandler)
      )
      this.connectLoader = true
      openedWindow = window.open(
        `${config.baseUrl}/api/facebook/start_oauth?location_id=${this.currentLocationId}&user_id=${this.userid}&launchpad=true`,
        'MyWindow',
        'toolbar=no, menubar=no,scrollbars=no,resizable=no,location=no,directories=no,status=no'
      )
      const timer = setInterval(async () => {
        if (openedWindow.closed) {
          clearInterval(timer)
          try {
            await this.fetchData()
          } catch (err) {}
          this.connectLoader = false
          if (this.facebookPages.length > 1 && !this.isFbConnected) {
            this.slideShow = true
            this.fbAuth = true
          } else if (!this.facebookPages.length) {
            this.disableHandler.disable = false
            this.$root.$emit(
              'disable-launchpad-action',
              JSON.stringify(this.disableHandler)
            )
          }
        }
      }, 500)
    },
    async fetchData() {
      try {
        this.facebookConnection = await OAuth2.getByLocationIdAndTypeOnce(
          this.currentLocationId,
          OAuth2.TYPE_FACEBOOK
        )
        if (this.facebookConnection) {
          const data = await AppEngineService.getFacebookPages(this.currentLocationId)

          this.facebookPages = data
          if (this.facebookPages.length == 1 && !this.location.facebookPageId) {
            this.selectedPage = this.facebookPages[0]
            this.selectedId = this.selectedPage.id
            this.disableHandler.disable = false
            this.$root.$emit(
              'disable-launchpad-action',
              JSON.stringify(this.disableHandler)
            )
            this.linkBusinessPage()
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    connectPage() {
      this.disableHandler.disable = true
      this.$root.$emit(
        'disable-launchpad-action',
        JSON.stringify(this.disableHandler)
      )
      this.slideShow = !this.slideShow
    },
    async linkBusinessPage() {
      if (!this.currentLocationId || !this.selectedPage) return

      try {
        if (this.processing) return
        this.processing = true
        await this.$http.post('/facebook/linkPage', {
          location_id: this.currentLocationId,
          page_id: this.selectedPage.id,
          page_token: this.selectedPage.access_token,
          page_name: this.selectedPage.name,
          page_link: this.selectedPage.link,
          instagram_page: this.selectedPage.instagram_business_account,
          launchpad: true,
          userId: this.userid,
        })
      } catch (err) {
        console.log(err)
      }
      await this.location.ref.update({
        is_fb_disconnected: false,
      })
      this.location = new Location(
        await this.$store.dispatch(
          'locations/getCurrentLocation',
          this.currentLocationId
        )
      )
      this.processing = false
      this.disableHandler.disable = false
      this.$root.$emit(
        'disable-launchpad-action',
        JSON.stringify(this.disableHandler)
      )
      this.slideShow = false
      trackGaEvent(
        'Launchpad',
        'Successfully Facebook connected',
        `Successfully Facebook connected for location: ${this.currentLocationId}`
      )
      this.$root.$emit('launchpad-status')
    },
    perfromAction() {
      if (this.isFbConnected) {
        return false
      } else if (this.fbAuth) {
        this.connectPage()
      } else if (!this.fbAuth) {
        this.showModal = !this.showModal
      }
    },
  },
})
